import ModalLayout from '../components/ModalLayout';
import { Button, Space } from 'antd';
import React from 'react';
import { useAuthMutation } from '../../../hooks/Auth';
import { auth } from '../../../auth/firebaseAuth';
import CenterLayout from '../../vendorlink-views/components/CenterLayout';
import Text from 'antd/lib/typography/Text';
import ErrorMessage from '../../auth-views/components/ErrorMessage';
import { useAuthState } from 'react-firebase-hooks/auth';

interface ResetPasswordStepProps {
  subtitle?: React.ReactNode;
  onCancel: () => void;
}

const ResetPasswordStep: React.FC<ResetPasswordStepProps> = ({ subtitle, onCancel }) => {
  const [user] = useAuthState(auth);
  const email = user?.email ?? undefined;
  const { useSendPasswordResetEmail } = useAuthMutation();
  if (!email) {
    return <></>;
  }
  const onSubmit = async () => {
    await useSendPasswordResetEmail.mutateAsync(email);
  };
  return (
    <CenterLayout>
      <ModalLayout
        header={
          <Space direction="vertical">
            <div className="heading-xs">Reset password</div>
            {subtitle ?? (
              <div className="text-content-secondary">
                We will send a secure link to{' '}
                <Text strong ellipsis>
                  {email}
                </Text>{' '}
                to reset your password.
              </div>
            )}
          </Space>
        }
        content={<ErrorMessage />}
        footer={
          <Space>
            <Button disabled={useSendPasswordResetEmail.isLoading} onClick={() => onSubmit()} type="primary">
              Send reset email
            </Button>
            <Button onClick={onCancel} type="text">
              Cancel
            </Button>
          </Space>
        }
      />
    </CenterLayout>
  );
};

export default ResetPasswordStep;
